import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { useEffect, useState } from "react";
import General from "../../stores/GeneralStore";
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import trashIcon from "../../assets/trash.svg";
import { ChangeEvent } from "react";
import { NotifyError } from "../../utils/ShowError";
import { set } from "mobx";

interface FileUpload {
  mediaType: string;
  fileName: string;
  buffer: string;
}

const MoveoutUpload = observer(
  ({
    onSubmit,
    submitLoader,
  }: {
    onSubmit: (files: any) => Promise<void>;
    submitLoader: Boolean;
  }) => {
    const [uploadedFiles, setUploadedFiles] = useState<any>([]);
    const [showLoader,setShowLoader] = useState(false); 
    useEffect(() => { 
      console.log("uploadedFiles", uploadedFiles);
    }, [uploadedFiles]);
    const [validationErrors, setValidationErrors] = useState<{
      [key: string]: boolean;
    }>({});
  
    const mandatoryDocumentsInitialState = [
      {
        // key: "EmirateIdCopy",
        // label: General?.codeLabels["cm_eid_copy"]?.label,
        key: "ServiceTermination",
        label: General?.codeLabels["cm_service_termination_form"]?.label,
      },
      {
        // key: "TenancyContract",
        // label: General?.codeLabels["cm_last_tenancy_contract"]?.label,
        key: "SignatoryID_PowerOfAttorney",
        label: General?.codeLabels["cm_sign_power_of_atterney"]?.label,
      },
      {
        key: "PowerOfAttorney",
        label: General?.codeLabels["cm_power_of_atterney"]?.label,
        // key: "OwnerTerminatioForm",
        // label: General?.codeLabels["cm_owner_letter"]?.label,
      },
      // {
      //   key: "FewaLetter",
      //   label: General?.codeLabels["cm_fewa_letter"]?.label,
      // },
    ];

    const [mandatoryDocuments, setMandatoryDocuments] = useState(
      mandatoryDocumentsInitialState
    );
    const addMoreDocuments = () => {
      const newDocument = {
        key: `newDocument${mandatoryDocuments.length}`,
        label: General?.codeLabels["cm_application_documents"]?.label,
      };
      setMandatoryDocuments([...mandatoryDocuments, newDocument]);
    };

    const handleRemoveField = (key: string) => {
      console.log(key);
      const documents = mandatoryDocuments.filter((d) => d.key != key);
      setMandatoryDocuments(documents);

      setValidationErrors((prevErrors) => {
        const { [key]: _, ...rest } = prevErrors;
        return rest;
      });
    };
    // const handleUploadFileChange = async (
    //   event: ChangeEvent<HTMLInputElement>,
    //   inputName: string,
    //   label: string
    // ) => {
    //   const files: FileList | null = event.target.files;
    //   console.log("files", files);
    //   const fileUploadPromises: Promise<FileUpload>[] = [];
    //    console.log("files", Boolean(files));
    //   if (files) {
    //     for (let i = 0; i < files.length; i++) {
    //       const file: File = files[i];
  
    //       // Check if the file is a PDF
    //       if (file.type === "application/pdf") {
    //         const promise = new Promise<FileUpload>((resolve, reject) => {
    //           const reader = new FileReader();
    //           reader.readAsDataURL(file);
    //           reader.onload = () => {
    //             const buffer = reader.result?.slice(28) as string;
    //             const fileName = file.name;
    //             const mediaType = file.type;
  
    //             const fileUpload: FileUpload = { mediaType, fileName, buffer };
    //             resolve(fileUpload);
    //           };
    //         });
  
    //         fileUploadPromises.push(promise);
    //       } else {
    //         NotifyError(
    //           General?.codeLabels["cm_complaint_error"]?.label !== undefined
    //             ? General?.codeLabels["cm_complaint_error"]?.label
    //             : "Only PDF files are allowed"
    //         );
    //       }
    //     }
  
    //     Promise.all(fileUploadPromises)
    //       .then((uploadedFilesfun) => {
    //         console.log("uploadedFilesfun", uploadedFilesfun);
    //         // setFieldValue("uploadedFilesData", uploadedFiles);
    //         // Update Formik field value
    //         const uploaded = [...uploadedFilesfun];
    //         // files.some((file:any) => {
          
    //         setUploadedFiles((prev: any) => [...prev, uploaded])
           
    //       })
    //       .catch((error) => {
    //         console.log("Error while processing file uploads:", error);
    //         NotifyError(General?.codeLabels["cm_complaint_error"]?.label);
    //       });
    //   }
    // };
    const handleUploadFileChange = async (
      event: ChangeEvent<HTMLInputElement>,
      inputName: string,
      key: string
    ) => {
      const files: FileList | null = event.target.files;
      if (!files || files.length === 0) return;

      const file: File = files[0]; // Only take the first file

      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/jpg", 
        "image/png"
      ];

      if (!allowedTypes.includes(file.type)) {
        NotifyError(
          General?.codeLabels["cm_complaint_error"]?.label !== undefined
            ? General?.codeLabels["cm_complaint_error"]?.label
            : "Only PDF, JPEG, JPG and PNG files are allowed"
        );
        return;
      }

      try {
        const fileUpload = await new Promise<FileUpload>((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const buffer = reader.result?.slice(
              // For images, slice from position 23, for PDFs from 28
              file.type.startsWith('image/') ? 23 : 28
            ) as string;
            const extension = file.name.substring(file.name.lastIndexOf("."));
            // const fileName = `${inputName}_${file.name}`;
            const fileName = `${inputName}_MoveOutAttachments${extension}`;
            const mediaType = file.type;
            resolve({ mediaType, fileName, buffer });
          };
          reader.onerror = reject;
        });

        setUploadedFiles((prev: any) => ({
          ...prev,
          [inputName]: fileUpload // Replace existing file for this input
        }));

        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [inputName]: false
        }));
        
      } catch (error) {
        console.log("Error while processing file upload:", error);
        NotifyError(General?.codeLabels["cm_complaint_error"]?.label);
      }
    };


    
    const handleFileEvent = (
      e: React.ChangeEvent<HTMLInputElement>,
      inputName: string,
      label: string
    ) => {
      const chosenFiles = e.target.files;

      if (chosenFiles && chosenFiles.length > 0) {
        const renamedFile = new File(
          [chosenFiles[0]],
          `${label}-${chosenFiles[0].name}`,
          { type: chosenFiles[0].type }
        );

        setUploadedFiles((prevFiles : any) => ({
          ...prevFiles,
          [inputName]: renamedFile,
        }));

        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [inputName]: false,
        }));
      }
    };

   

    const handleSubmit = () => {
       const missingMandatoryDocuments = mandatoryDocuments.filter(
        (doc) => !uploadedFiles[doc.key]
      );

      if (missingMandatoryDocuments.length > 0) {
        const newErrors: { [key: string]: boolean } = {};
        missingMandatoryDocuments.forEach((doc) => {
          newErrors[doc.key] = true;
        });
        setValidationErrors(newErrors);
        return;
      }
      setShowLoader(true);
      onSubmit(uploadedFiles);
    };

    return (
      <>
        <TabContainer
          style={{
            flexDirection: "column",
            display: General?.isLargeScreen ? "" : "flex",
          }}
        >
          <p
            style={{
              gridColumn: "1 / span 2",
              paddingTop: "10px",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "20px",
              color: General?.contrast?.contrastColor
                ? General?.contrast?.contrastColor
                : General?.ColorAss,
            }}
          >
            {General?.codeLabels["cm_pdc_all"]?.label
              ? General?.codeLabels["cm_pdc_all"]?.label
              : "Upload all mandatory documents and use optional documents feature for any supporting documents"}
          </p>
          {mandatoryDocuments.map((doc) => (
            <div key={doc.key}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width:
                      doc.label ==
                      General?.codeLabels["cm_application_documents"]?.label
                        ? "100%"
                        : "100%",
                  }}
                >
                  <Document
                    exists={uploadedFiles[doc.key] !== undefined}
                    // exists={false}
                    mainText={doc.label}
                    subText={
                      uploadedFiles[doc.key]?.name ||
                      General?.codeLabels["cm_mandatory_document"]?.label ||
                      "Mandatory Document"
                    }
                    onChange={(e) => {
                      // handleFileEvent(e, doc.key, doc?.label);
                      handleUploadFileChange(e, doc.key, doc?.label);
                      // Reset the file input value after selection
                      // e.target.value = "";
                    }}
                    inputName={doc.key}
                    name={uploadedFiles[doc.key]?.fileName}
                    label={doc?.key}
                    key={`${doc.key}-${uploadedFiles[doc.key]?.fileName || ""}`}
                    moveout={true}
                    acceptFileType={"application/pdf, image/jpeg, image/jpg, image/png"}
                  />
                  {doc.key === "ServiceTermination" && (
                    <p
                      style={{
                        margin: "8px 0 0 0",
                        fontSize: "0.9rem",
                        color: General?.contrast?.contrastColor || "#000",
                      }}
                    >
                      
                      <a
                        href="/forms/ASPCL-Forms-Service-Termination-Request-v1.2.pdf"
                        target="_blank"
                        rel="noreferrer"
                        download
                        style={{
                          color: General?.contrast?.contrastColor || "#101E8E",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {General?.codeLabels["cm_download_form"]?.label || "Download Form"}
                      </a>
                    </p>
                  )}
                  {validationErrors[doc.key] && (
                    <p
                      style={{
                        color: "red",
                        margin: "4px 0 0 0",
                        fontWeight: "bold",
                      }}
                    >
                      {General?.codeLabels["cm_socialcasenofileerr"]?.label
                        ? General?.codeLabels["cm_socialcasenofileerr"]?.label
                        : "Please upload file for"}{" "}
                      {doc.label}
                    </p>
                  )}
                </div>
                <div>
                  {(uploadedFiles[doc.key] ||
                    doc.label ==
                      General?.codeLabels["cm_application_documents"]
                        ?.label) && (
                    <button
                      type="button"
                      style={{
                        cursor: "pointer",
                        background: "none",
                        border: 0,
                      }}
                      onClick={() => {
                        if (
                          doc.label ==
                          General?.codeLabels["cm_application_documents"]?.label
                        ) {
                          handleRemoveField(doc.key);
                        } else {
                          setUploadedFiles((prev : any) => {
                            const newFiles = { ...prev };
                            delete newFiles[doc.key];
                            return newFiles;
                          });
                        }
                      }}
                    >
                      <img src={trashIcon} alt="Remove Attachment" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
          <Label>
            <div
              style={{
                height: "43px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ButtonSecondary
                style={{
                  alignSelf: "end",
                  width: General?.isLargeScreen ? "205px" : "98%",
                  height: "36px",
                  background: General?.contrast?.contrastBackground
                    ? General?.contrast?.contrastBackground
                    : "#FFFFFF",
                  border: General?.contrast?.contrastColor
                    ? `1px solid ${General?.contrast?.contrastColor}`
                    : " 1px solid #101E8E",
                  fontWeight: "900",
                  padding: "10px 0",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  lineHeight: "16px",
                  color: General?.contrast?.contrastColor
                    ? General?.contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={addMoreDocuments}
              >
                {General?.codeLabels["cm_add_more"]?.label
                  ? General?.codeLabels["cm_add_more"]?.label
                  : "ADD MORE DOCUMENTS"}
              </ButtonSecondary>
            </div>
          </Label>
          <hr
            style={{
              gridColumn: "1 / span 2",
              width: "100%",
              backgroundColor: "#101E8E",
              mixBlendMode: "normal",
              opacity: "0.2",
            }}
          />
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen ? "168px" : "98%",
              height: "50px",
              background: General?.contrast?.contrastColor
                ? General?.contrast?.contrastColor
                : "#101e8e",
              color: General?.contrast?.contrastBackground
                ? General?.contrast?.contrastBackground
                : "#fff",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "16px",
              opacity: showLoader ? 0.6 : 1,
              cursor: showLoader ? "not-allowed" : "pointer",
            }}
            disabled={showLoader}
            onClick={handleSubmit}
          >
            {showLoader ? (
              <Spinner width="30px" height="30px" />
            ) : General?.codeLabels["cm_submit"]?.label !== undefined ? (
              General?.codeLabels["cm_submit"]?.label
            ) : (
              "SUBMIT"
            )}
          </ButtonSecondary>
        </TabContainer>
      </>
    );
  }
);

export default MoveoutUpload;
